import { Field } from 'formik';
import useFormikError from 'hooks/useFormikError';
import { useEffect, useState } from 'react';
import InputBase, { inputClass } from './InputBase';
import InputSlug from './InputSlug';

interface Props {
  name: string;
  /**
   * If not provided, the label will be the same as the name
   */
  label?: JSX.Element | string;
  type?:
    | 'text'
    | 'number'
    | 'textarea'
    | 'email'
    | 'password'
    | 'slug'
    | 'date';
  disabled?: boolean;
  placeholder?: string;
  autoFocus?: boolean;
  defaultValue?: string | null;
  autocomplete?: {
    field: string;
    type?: 'slug';
  };
  icon?: JSX.Element | string | number;
  slim?: boolean;
  helperText?: string | null;
}

const Input: React.FC<Props> = ({
  label,
  name,
  type,
  disabled,
  placeholder = '',
  autocomplete,
  icon,
  slim = false,
  autoFocus,
  defaultValue,
  helperText,
}) => {
  const error = useFormikError(name);
  const [ref, setRef] = useState();

  useEffect(() => {
    if (autoFocus && ref) {
      //@ts-ignore
      ref.focus();
    }
  }, [autoFocus, ref]);

  return (
    <InputBase
      icon={icon}
      label={label}
      name={name}
      autocomplete={autocomplete}
      slim={slim}
      defaultValue={defaultValue}
      helperText={helperText}
    >
      {type === 'slug' ? (
        <InputSlug disabled={disabled} name={name} placeholder={placeholder} />
      ) : type === 'textarea' ? (
        <Field
          innerRef={autoFocus && setRef}
          as="textarea"
          disabled={disabled}
          className={inputClass(!!error, slim) + " min-h-[130px]"}
          name={name}
          id={name}
          placeholder={placeholder}
          rows={3}
        />
      ) : (
        <Field
          innerRef={autoFocus && setRef}
          disabled={disabled}
          className={inputClass(!!error, slim)}
          name={name}
          id={name}
          type={type}
          placeholder={placeholder}
        />
      )}
    </InputBase>
  );
};

export default Input;
